import React, { useEffect, useState } from "react";
import api from "@/services/api";
import Pagination from "@/components/Paginator";

const ListSourcesActive = () => {
  const [total, setTotal] = useState(0);
  const [sources, setSources] = useState([]);
  const [filter, setFilter] = useState({ page: 1, pageSize: 100 });

  useEffect(() => {
    loadSources();
  }, [filter]);

  async function loadSources() {
    try {
      const { ok, data, total } = await api.post("/mission_ao_source/search", { ...filter, active: true });
      if (!ok) {
        console.error("Error fetching active sources");
        return;
      }
      setSources(data);
      setTotal(total);
    } catch (error) {
      console.error(error);
    }
  }

  function formatDate(dateStr) {
    return dateStr ? new Date(dateStr).toLocaleString() : "";
  }

  function getStatusClass(status) {
    if (status === "Completed") return "bg-green-100 text-green-800";
    if (status === "Failed") return "bg-red-100 text-red-800";
    if (status === "In progress") return "bg-yellow-100 text-yellow-800";
    return "bg-gray-100 text-gray-800";
  }

  function getStatusDot(status) {
    if (status === "Completed") return "bg-green-500";
    if (status === "Failed") return "bg-red-500";
    if (status === "In progress") return "bg-yellow-500";
    return "bg-gray-500";
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Sources</h1>
        <p className="text-gray-600">Monitor all currently active data sources</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex flex-1 items-center justify-end mb-6">
          <div className="text-sm font-medium text-gray-700 bg-gray-100 px-3 py-1 rounded-full">
            {total} source{total !== 1 ? "s" : ""}
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">URL</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Last Scrapped</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">AOs</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {(sources || []).map((source) => (
                <tr key={source._id} className="hover:bg-blue-50 transition-colors duration-150">
                  <td className="px-6 py-4">
                    <div className="font-medium text-gray-900">{source.name}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <span className={`h-2.5 w-2.5 rounded-full ${getStatusDot(source.scrapped_status)} mr-2`}></span>
                      <span className={`px-2.5 py-1 inline-flex text-xs font-medium rounded-full ${getStatusClass(source.scrapped_status)}`}>{source.scrapped_status}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm max-w-xs truncate">
                    <a href={source.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline truncate block" title={source.url}>
                      {source.url}
                    </a>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600">{formatDate(source.scrapped_at) || "-"}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {source.ao_count || 0}
                    </span>
                  </td>
                </tr>
              ))}
              {sources.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-6 py-8 text-center text-gray-500">
                    No active sources found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex w-full mt-5 justify-center">
          <Pagination page={filter.page} setPage={(page) => setFilter({ ...filter, page })} last={Math.ceil(total / filter.pageSize)} />
        </div>
      </div>
    </div>
  );
};

export default ListSourcesActive;
